// SocialShareButtons.js

import React from "react";
import { FacebookShareButton, FacebookMessengerShareButton, WhatsappShareButton} from "react-share";
import { FacebookIcon, FacebookMessengerIcon, WhatsappIcon } from "react-share";

const SocialShareButtons = ({ url }) => {
  return (
    <div style={{ display: "flex", gap: "10px",marginTop:"8px" }}>
      {/* Bouton de partage Facebook */}
      <FacebookShareButton url={url}>
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton>

      {/* Bouton de partage Messenger */}
      <FacebookMessengerShareButton url={url}>
        <FacebookMessengerIcon size={32} round={true} />
      </FacebookMessengerShareButton>

      {/* Bouton de partage WhatsApp */}
      <WhatsappShareButton url={url}>
        <WhatsappIcon size={32} round={true} />
      </WhatsappShareButton>

     
    </div>
  );
};

export default SocialShareButtons;

